import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import { dyn } from "trader.ts/ui";
import { Form } from "trader.ts/ui.forms";
import {
  formulaquestionid,
  price_adapted_to_lg_and_student,
} from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { questionsField } from "../../client/questionsField";
import { renderSaveButton } from "../../client/savebutton";
import {
  non_periodic_payment_scheme,
  periodic_payment_scheme,
} from "../../domain/config";
import { invoicelineStudent } from "../../domain/finance/types";
import { isNil } from "../../lib/istype";
import { invoicelinetype } from "../../parsing_from_ur";
import {
  confirmReenrollmentSpec,
  payEnrollmentrequestRoute,
  rejectReenrollmentSpec,
} from "../../routes";
import { enrollmentrequest_full } from "../approve_enrollment_request/server";
import {
  accountInfoField,
  agreedToTermsField,
  formulaQuestion,
  paymentSchemeChoiceField,
  selectedOptionalInvoiceLinesField,
} from "../public_new_enrollment/client";

export function render({
  req,
  invoicelines,
  eachPeriodInvoiceLines,
  possiblePaymentSchemes,
  questions,
  termsurl,
}: {
  termsurl: string | null;
  req: enrollmentrequest_full;
  invoicelines: (invoicelineStudent & {
    type_: invoicelinetype;
  })[];
  eachPeriodInvoiceLines: {
    amount: price_adapted_to_lg_and_student;
    vat: number;
    description: string;
    type_: invoicelinetype;
  }[];
  possiblePaymentSchemes: (
    | periodic_payment_scheme
    | non_periodic_payment_scheme
  )[];
  questions: formulaQuestion[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("questions", [], () =>
      questionsField<{ formulaquestionid: formulaquestionid }>(
        questions.map((q) => ({
          ...q,
          formulaquestionid: q.id,
          number_answer: null,
          text_answer: null,
          boolean_answer: null,
          select_answer: null,
          multiselect_answers: null,
        })),
      ),
    )
    .addField("optionalInvoiceLines", [], async () => {
      return selectedOptionalInvoiceLinesField({
        hide_invoicelines: false,
        max_one_optional_line: req.contents.formula.max_one_optional_line,
        optionalInvoiceLines: [
          ...invoicelines,
          ...eachPeriodInvoiceLines,
        ].filter((il) => il.type_ === "Optional" || il.type_ === "Discount"),
      });
    })
    .addField("agreedToTerms", [], () => {
      return agreedToTermsField({ termsurl });
    })
    .addField(
      "paymentScheme",
      ["optionalInvoiceLines"],
      async ({ optionalInvoiceLines }) => {
        return paymentSchemeChoiceField({
          possiblePaymentSchemes,
          optionalInvoiceLines,
          mandatoryInvoiceLines: [
            ...invoicelines,
            ...eachPeriodInvoiceLines,
          ].filter((il) => il.type_ === "Normal"),
        });
      },
    )
    .addField("accountInfo", ["paymentScheme"], ({ paymentScheme }) => {
      // This page is accessible without a token, so it would be unsafe to
      // show the account info here. We just ask it again.
      return accountInfoField(paymentScheme, null);
    })
    .build({
      render: (fields) => (
        <div>
          {fields.optionalInvoiceLines()}
          {fields.paymentScheme()}
          {fields.accountInfo()}
          {fields.questions()}
          {fields.agreedToTerms()}
        </div>
      ),
    });

  const rejectingS = new Source(false);

  return (
    <div>
      <section>{form.render()}</section>
      <article style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: async function (form) {
            const res = await rpc(confirmReenrollmentSpec, undefined, {
              enrollmentrequestid: req.id,
              requestedOptionalInvoiceLines: form.optionalInvoiceLines,
              payment_scheme_id: form.paymentScheme.id,
              questions: form.questions,
              accountInfo: form.accountInfo,
            });
            if (res.tag === "error") {
              return res;
            } else {
              if (!isNil(res.immediatePaymentNeeded)) {
                return {
                  tag: "success",
                  timeout: 1000,
                  redirectUrl: payEnrollmentrequestRoute.link({
                    enrollmentrequestid: res.immediatePaymentNeeded,
                  }),
                };
              } else {
                return {
                  tag: "success",
                  timeout: 3000,
                  redirectUrl: window.location.toString(),
                };
              }
            }
          },
          text: {
            normal: "Ja, schrijf mij opnieuw in!",
            success: "Gelukt!",
          },
          reload: false,
        })}
      </article>
      <article style="text-align: right">
        <a onclick={() => rejectingS.set(true)}>
          {"Nee, ik wil niet opnieuw inschrijven"}
        </a>
      </article>
      {dyn(rejectingS, (rejecting) => {
        if (rejecting === true) {
          return (
            <div className={style.panel + style.slide_in}>
              {"Ben je zeker dat je je niet opnieuw wilt inschrijven?"}
              <div style="text-align: right">
                {renderSaveButton({
                  save: () => {
                    return rpc(rejectReenrollmentSpec, undefined, {
                      enrollmentrequestid: req.id,
                    });
                  },
                  text: {
                    normal: "Ja, ik ben zeker",
                    success: "Gelukt",
                  },
                  reload: true,
                  timeout: 3000,
                })}
              </div>
            </div>
          );
        } else {
          return <span></span>;
        }
      })}
    </div>
  );
}
